import { render } from "./CreateMotif.vue?vue&type=template&id=77ffa274"
import script from "./CreateMotif.vue?vue&type=script&lang=js"
export * from "./CreateMotif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__